import { ResetPasswordPage } from '@/pages/forgot-password';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_public/reset-password')({
  component: ResetPasswordPage,
});
